import React from 'react'
import { string, array } from 'prop-types'
import AboutBrand from '@/component/Primitive/Brand/component/AboutBrand'

const AboutBrandWidget = ({
  description,
  latestMagazineIssues,
  lightLogoUrl
}) => {
  const items = latestMagazineIssues.map((mi) => ({
    imgUrl: mi.images.cover_321x446_270[0].url,
    retinaImgUrl: mi.images.cover_321x446_540[0].url,
    slug: mi.slug
  }))

  const widgetProps = {
    description,
    items,
    logo: lightLogoUrl
  }

  return <AboutBrand {...widgetProps} />
}

AboutBrandWidget.propTypes = {
  description: string,
  latestMagazineIssues: array,
  lightLogoUrl: string
}

export default AboutBrandWidget
